export default [
  {
    path: '/dash/integration',
    name: 'Integration',
    component: () => import('@/modules/integration/pages/IntegrationTabs.vue'),
    meta: {
      authRequired: true,
      pageTitle: 'Integration',
      breadcrumb: [
        {
          text: 'Integration',
          active: true,
        },
      ],
    },
  },
  {
    path: '/dash/integration/chrome',
    name: 'IntegrationChromeExtension',
    component: () => import('@/modules/integration/pages/IntegrationTabs.vue'),
    meta: {
      authRequired: true,
      pageTitle: 'Chrome Extension',
      breadcrumb: [
        {
          text: 'Integration of Chrome Extension',
          active: true,
        },
      ],
    },
  },
  {
    path: '/dash/integration/api',
    name: 'IntegrationApis',
    component: () => import('@/modules/integration/pages/IntegrationTabs.vue'),
    meta: {
      authRequired: true,
      pageTitle: 'APIs',
      breadcrumb: [
        {
          text: 'Integration of APIs',
          active: true,
        },
      ],
    },
  },
  {
    path: '/dash/integration/api/v2/:id?',
    name: 'IntegrationApiV2',
    component: () => import('@/modules/integration/pages/ApiIntegrationV2.vue'),
    meta: {
      authRequired: true,
      pageTitle: 'ApiV2',
      breadcrumb: [
        {
          text: 'Documentation for Integrating New APIs',
          active: true,
        },
      ],
    },
  },
];
